import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '../contexts/ApiClientContext'
import type { SuggestionsRequest } from '@kwry/common'

export interface UseSuggestionsOptions {
  context?: {
    articleTitle?: string
    articleContent?: string
    articleUrl?: string
  }
  language?: string
  enabled?: boolean
}

export function useSuggestions({ 
  context,
  language,
  enabled = true 
}: UseSuggestionsOptions) {
  const apiClient = useApiClient()
  
  return useQuery({
    queryKey: [
      'suggestions', 
      context?.articleTitle,
      context?.articleContent,
      language
    ],
    queryFn: async () => {
      const requestData: SuggestionsRequest & { language?: string } = {
        context: {
          articleTitle: context?.articleTitle,
          articleContent: context?.articleContent,
          articleUrl: context?.articleUrl
        },
        projectId: '', // ApiClient handles this via headers
        language
      }
      
      return apiClient.getSuggestions(requestData)
    },
    enabled: enabled && !!(context?.articleTitle || context?.articleContent),
    staleTime: 10 * 60 * 1000, // 10 minutes - suggestions don't change often
    retry: 2,
  })
} 